var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliticalDebateAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st1{fill:#F1AB1E;}\n\t.st2{opacity:0.5;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{opacity:0.65;}\n\t.st5{fill:#E0E0E0;}\n\t.st6{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{opacity:0.2;enable-background:new    ;}\n\t.st9{fill:#455A64;}\n\t.st10{fill:#37474F;}\n\t.st11{fill:#263238;}\n\t.st12{opacity:0.15;enable-background:new    ;}\n\t.st13{fill:#B16668;}\n\t.st14{fill:#9A4A4D;}\n\t.st15{fill:#FAFAFA;}\n\t.st16{fill:#F28F8F;}\n\t.st17{opacity:0.25;enable-background:new    ;}\n\t.st18{fill:#E6E6E6;}\n\t.st19{fill:#FFBDA7;}\n\t.st20{fill:#F0997A;}\n\t.st21{opacity:0.35;enable-background:new    ;}\n\t.st22{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-3",
    className: "st0",
    cx: 250,
    cy: 348.4,
    rx: 235.6,
    ry: 136
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.2,343.3c0,0,4.3-21.2-3.1-43.2c-4.1-12.3-12-18.1-16.9-18.7c-5.5-0.7-11.1,4.4-6.4,12.5 c4.5,7.7,13.3,11,18.1,31c1.5,6.2,2.4,12.5,2.5,18.8c0,1,0.7,1.7,1.7,1.8c0.3,0,0.6-0.1,0.9-0.2L49.2,343.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.2,343.3c0,0,4.3-21.2-3.1-43.2c-4.1-12.3-12-18.1-16.9-18.7c-5.5-0.7-11.1,4.4-6.4,12.5 c4.5,7.7,13.3,11,18.1,31c1.5,6.2,2.4,12.5,2.5,18.8c0,1,0.7,1.7,1.7,1.8c0.3,0,0.6-0.1,0.9-0.2L49.2,343.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46,338.6c-0.2,0-0.3-0.2-0.3-0.4c2.9-24.3-8.4-44.9-17.3-51.8c-0.1-0.1-0.2-0.3-0.1-0.5c0,0,0,0,0,0 c0.1-0.1,0.3-0.2,0.5-0.1c9.1,7,20.5,27.9,17.6,52.4C46.4,338.5,46.2,338.6,46,338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,345.5c-0.8,0.5-1.9,0.2-2.4-0.6c-0.1-0.2-0.2-0.3-0.2-0.5c-1.2-4.9-4.1-9.9-9.7-15.3 c-6.5-6.2-15.5-12-14.1-17.4s8.6-4.1,13.7-1.1s16.2,14.6,13.5,34.3L45.5,345.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.5,345.5c-0.8,0.5-1.9,0.2-2.4-0.6c-0.1-0.2-0.2-0.3-0.2-0.5c-1.2-4.9-4.1-9.9-9.7-15.3 c-6.5-6.2-15.5-12-14.1-17.4s8.6-4.1,13.7-1.1s16.2,14.6,13.5,34.3L45.5,345.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45,345.9c-0.2,0-0.3-0.2-0.3-0.3c0.6-14.9-11.7-31.5-20.5-34.6c-0.2-0.1-0.3-0.2-0.2-0.4c0,0,0,0,0,0 c0.1-0.2,0.3-0.3,0.4-0.2c8.8,2.3,22.3,20.3,21,35.2c0,0.2-0.1,0.3-0.3,0.4L45,345.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3_00000068671528432170220570000010217785635170969529_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M455.7,346c0,0-4.3-21.2,3.1-43.2c4.1-12.3,12-18.1,16.9-18.7c5.5-0.7,11.1,4.4,6.5,12.5 c-4.5,7.7-13.3,11-18.1,31c-1.5,6.2-2.4,12.5-2.5,18.8c0,1-0.8,1.7-1.8,1.7c-0.3,0-0.6-0.1-0.9-0.2L455.7,346z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M455.7,346c0,0-4.3-21.2,3.1-43.2c4.1-12.3,12-18.1,16.9-18.7c5.5-0.7,11.1,4.4,6.5,12.5 c-4.5,7.7-13.3,11-18.1,31c-1.5,6.2-2.4,12.5-2.5,18.8c0,1-0.8,1.7-1.8,1.7c-0.3,0-0.6-0.1-0.9-0.2L455.7,346z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M459,341.2c0.2,0,0.3-0.2,0.3-0.4c0,0,0,0,0,0c-2.9-24.3,8.4-44.9,17.3-51.8c0.1-0.1,0.2-0.3,0.1-0.5 s-0.3-0.2-0.5-0.1c-9.1,7-20.5,27.9-17.6,52.4C458.6,341.1,458.8,341.2,459,341.2C459,341.2,459,341.2,459,341.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.5,348.2c0.8,0.5,1.9,0.2,2.4-0.6c0.1-0.2,0.2-0.3,0.2-0.5c1.2-4.9,4.1-9.9,9.8-15.3 c6.5-6.2,15.5-12,14.1-17.4s-8.6-4.1-13.7-1.1s-16.2,14.6-13.6,34.4L459.5,348.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M459.5,348.2c0.8,0.5,1.9,0.2,2.4-0.6c0.1-0.2,0.2-0.3,0.2-0.5c1.2-4.9,4.1-9.9,9.8-15.3 c6.5-6.2,15.5-12,14.1-17.4s-8.6-4.1-13.7-1.1s-16.2,14.6-13.6,34.4L459.5,348.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M460,348.6c0.2,0,0.3-0.2,0.3-0.3c-0.6-14.9,11.7-31.5,20.5-34.6c0.2-0.1,0.3-0.3,0.2-0.4c0,0,0,0,0,0 c-0.1-0.2-0.3-0.3-0.4-0.2c-8.8,2.3-22.3,20.3-21,35.2c0,0.2,0.1,0.3,0.3,0.4L460,348.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-3",
    className: "st5",
    cx: 78.9,
    cy: 365.3,
    rx: 50.3,
    ry: 29.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    className: "st5",
    cx: 420.5,
    cy: 365.3,
    rx: 50.4,
    ry: 29.1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3_00000142152951333246159880000000505283312313745572_",
    className: "st5",
    points: "149.5,438  69.5,391.8 149.5,345.5 229.6,391.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3_00000135693376846820972060000004183595402814196406_",
    className: "st5",
    points: "352.6,438  272.6,391.8 352.6,345.5 432.6,391.8  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flag--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M265.8,322.1c-8.8-5-22.9-5-31.7,0c-4.4,2.5-6.6,5.8-6.5,9.1v3.4c0,3.3,2.2,6.6,6.5,9.1c8.8,5,22.9,5,31.7,0 c4.4-2.5,6.5-5.8,6.5-9.1v-3.4C272.4,328,270.2,324.7,265.8,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M265.8,322.1c-8.8-5-22.9-5-31.7,0c-4.4,2.5-6.6,5.8-6.5,9.1v3.4c0,3.3,2.2,6.6,6.5,9.1c8.8,5,22.9,5,31.7,0 c4.4-2.5,6.5-5.8,6.5-9.1v-3.4C272.4,328,270.2,324.7,265.8,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.2,322.1c-8.8,5-8.8,13.2,0,18.3s22.9,5,31.7,0s8.8-13.2,0-18.3S242.9,317.1,234.2,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M234.2,322.1c-8.8,5-8.8,13.2,0,18.3s22.9,5,31.7,0s8.8-13.2,0-18.3S242.9,317.1,234.2,322.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M264.2,318.9c-7.9-4.5-20.6-4.5-28.5,0c-3.9,2.3-5.9,5.2-5.9,8.2v2.2c0,3,1.9,5.9,5.9,8.2 c7.9,4.5,20.6,4.5,28.5,0c3.9-2.3,5.9-5.2,5.9-8.2v-2.2C270.1,324.1,268.2,321.2,264.2,318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M264.2,318.9c-7.9-4.5-20.6-4.5-28.5,0c-3.9,2.3-5.9,5.2-5.9,8.2v2.2c0,3,1.9,5.9,5.9,8.2 c7.9,4.5,20.6,4.5,28.5,0c3.9-2.3,5.9-5.2,5.9-8.2v-2.2C270.1,324.1,268.2,321.2,264.2,318.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 250,
    cy: 327.1,
    rx: 20.1,
    ry: 11.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 250,
    cy: 327.1,
    rx: 20.1,
    ry: 11.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252,43.7c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2v283.5l0,0c0,0.4,0.3,0.7,0.6,0.8c0.9,0.4,1.9,0.4,2.8,0 c0.3-0.1,0.5-0.5,0.6-0.8l0,0L252,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252,43.7c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2v283.5l0,0c0,0.4,0.3,0.7,0.6,0.8c0.9,0.4,1.9,0.4,2.8,0 c0.3-0.1,0.5-0.5,0.6-0.8l0,0L252,43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M250,41.7L250,41.7c-1.1,0-2,0.9-2,2V46c1.3,0.5,2.7,0.5,4,0v-2.3C252,42.6,251.1,41.7,250,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.5,39.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C253,34.2,255.5,36.7,255.5,39.7 C255.5,39.7,255.5,39.7,255.5,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M255.5,39.7c0,3-2.5,5.5-5.5,5.5s-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5C253,34.2,255.5,36.7,255.5,39.7 C255.5,39.7,255.5,39.7,255.5,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M232.3,225.2c-1.3,14.4,15.8,34.5,40.8,32.9l-9.5-82l-26.4,3.6L232.3,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M233.1,221c-0.4,1.2-0.7,2.4-0.9,3.6l8.5-77.2c14.5,4.5,26.1,16.2,28.2,33.1 C271.3,198.7,239.5,201.4,233.1,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M252.4,34.8c-1.5-0.8-3.4-0.8-4.9,0C248.9,36.2,251,36.2,252.4,34.8C252.4,34.8,252.4,34.8,252.4,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.5,29.6c0,2.5-2,5.4-4.5,5.4s-4.5-2.9-4.5-5.4s4.5-13.4,4.5-13.4S254.5,27.2,254.5,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M254.5,29.6c0,2.5-2,5.4-4.5,5.4s-4.5-2.9-4.5-5.4s4.5-13.4,4.5-13.4S254.5,27.2,254.5,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M252,50.7l-24.8,99.7c0,0,20.1,5.6,27.7,10.7c12.6,8.4,14.1,19.6,14.1,19.6L252,50.7z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.6,360.2 405.6,358.3 407.2,355 410.3,357.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M415.6,351.3c0,0,0.2,3.2,0.3,4.2s-4.2,4.2-5.3,4.7l-0.3-2.4c-1,1.2-1.8,2.5-2.4,3.8 c-0.8,1.4-1.9,4.2-4.1,6c-3.4,2.8-8.6,4.2-14,4.4s-8.4-1.1-10-2.2s-2-2.5-1.6-3.9S415.6,351.3,415.6,351.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M401.2,340.4l-0.1-1.9c-1,0-1.1,2.7-2.5,5c-2.1,3.5-4.6,6.8-7.5,9.7c-5.4,5-10.2,8.1-12.7,10.4 c-3.2,3,2.5,7.7,11.2,7.2c4.4-0.3,12-2.5,14.2-5.1s3.5-6.6,5.2-8.5s5.4-3.8,6.5-6c0.6-1.2,0.3-4.1-0.1-6.6 c-0.3-2.3-0.4-5.7-1.7-5.5l-0.1,1.2c-0.5,1-1.7,2.6-5.2,3.2C406.7,343.9,401.5,344.1,401.2,340.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M405.7,343.7c-1.7-0.1-3.5-0.7-4.2-2.2v0c0.2,1.3-0.2,2.6-1.1,3.6c-1.6,1.8-11.4,14.8-11.4,14.8 s9.1-10.7,10.9-12.7C402.5,344.2,403.3,343.8,405.7,343.7L405.7,343.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M378.4,363.7c2-1.9,5.8-4.4,10.2-8.2c-0.9,1.5-2.3,2.6-2.4,3.1c-0.3,1.2,3.3,2.9,5.5,3.5s4.7-2.6,7.9-5.4 s6.1,0.5,7.2,4.4c-0.8,1.7-1.8,3.3-2.9,4.7c-2.2,2.6-9.9,4.8-14.2,5.1C380.9,371.4,375.2,366.7,378.4,363.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M403.5,347.2c0,0.3,0.3,0.5,0.6,0.5c0,0,0,0,0,0c0.3,0,0.5-0.3,0.5-0.6c0-0.3-0.3-0.5-0.6-0.5 C403.7,346.6,403.5,346.8,403.5,347.2C403.5,347.1,403.5,347.2,403.5,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M400.9,350c0,0.3,0.3,0.5,0.6,0.5c0,0,0,0,0,0c0.3,0,0.5-0.3,0.5-0.6s-0.3-0.5-0.6-0.5 C401.1,349.4,400.9,349.7,400.9,350C400.9,350,400.9,350,400.9,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M398.4,352.9c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.5-0.3,0.5-0.6s-0.3-0.5-0.6-0.5 C398.5,352.3,398.3,352.6,398.4,352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M395.8,355.8c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.5-0.3,0.5-0.6c0-0.3-0.3-0.5-0.6-0.5 C396,355.2,395.8,355.5,395.8,355.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M393.2,358.6c0.1,0.3,0.3,0.5,0.6,0.4c0.3-0.1,0.4-0.3,0.4-0.5c-0.1-0.3-0.3-0.5-0.6-0.4 C393.4,358.1,393.2,358.4,393.2,358.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M404.1,347.3c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0-0.3c0,0,0,0,0,0c-1.6-1.5-3.8-2.4-6.1-2.4l0,0 c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c2.1,0,4.2,0.8,5.7,2.2C403.9,347.3,404,347.3,404.1,347.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M401.5,350.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0-0.1-0.1-0.1c-1.6-1.5-3.8-2.4-6.1-2.4l0,0 c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c2.1,0,4.2,0.8,5.7,2.2C401.4,350.2,401.4,350.2,401.5,350.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M398.9,353c0.1,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0-0.3c-1.6-1.5-3.8-2.4-6.1-2.4l0,0 c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c2.1,0,4.2,0.8,5.7,2.2C398.8,353,398.9,353.1,398.9,353z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M396.4,355.9c0.1,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0-0.3c-1.6-1.5-3.8-2.4-6.1-2.4l0,0 c-0.1,0-0.2,0.1-0.2,0.3c0,0.1,0.1,0.2,0.2,0.2c2.1,0,4.2,0.8,5.7,2.2C396.2,355.9,396.3,355.9,396.4,355.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M393.8,358.8c0.1,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0-0.3c-1.7-1.5-3.8-2.4-6.1-2.4l0,0 c-0.1,0-0.2,0-0.3,0.2c0,0.1,0,0.2,0.2,0.3c0,0,0.1,0,0.1,0c2.1,0,4.2,0.8,5.7,2.2C393.6,358.8,393.7,358.8,393.8,358.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M439.7,371.6c0,4.1,0.5,6.8,1.9,9.3s4,3.4,6.8,2.8s6.5-2.3,7.4-5.8c0.9-3.2,1-6.5,0.5-9.7L439.7,371.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M453.3,342.3c1.1,0.1,0.6,5.3,1,10.8c0.2,2.8,0.1,5.4,0.6,7.3c0.6,2.1,1.1,4.3,1.3,6.5c0.5,5.5,0,8-2,11.2 s-9.1,6.2-12.2,1.2c-2.6-4-2.5-8.4-2-13.9c0.5-5.7-0.2-9.6-0.3-14c0-4.1-1.2-8.5,0.5-8.5c0,0.6,0.1,1.4,0.1,2s0,2.7,0.7,2.8 c0.1-0.5,0.1-1,0.1-1.6c0-0.5,0.1-0.9,0.4-1.3c0.4-0.3,0.8-0.5,1.3-0.5c1.1-0.2,3.8-0.5,5-0.5c0.6,0,2.3-0.2,2.8-0.2 c0.5,0,1,0.1,1.4,0.3c0.3,0.1,0.5,0.3,0.6,0.6c0,0.2,0,0.4,0,0.6c0,0.4,0,0.8,0.1,1.1c0,0.2,0.1,0.4,0.3,0.3s0.2-0.2,0.2-0.3 c0-0.7,0-1.2,0-1.9c0-0.4,0-0.9,0-1.2S453.3,342.7,453.3,342.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M452,368.1c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4 c0,0,0,0,0,0C451.8,367.8,452,367.9,452,368.1C452,368.1,452,368.1,452,368.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M451.8,364.3c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 C451.6,363.9,451.8,364.1,451.8,364.3C451.8,364.3,451.8,364.3,451.8,364.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M451.6,360.7c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 C451.4,360.3,451.6,360.5,451.6,360.7C451.6,360.7,451.6,360.7,451.6,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M451.4,357.2c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 C451.2,356.8,451.4,357,451.4,357.2C451.4,357.2,451.4,357.2,451.4,357.2L451.4,357.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M443.9,357.3c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 C443.7,356.9,443.9,357.1,443.9,357.3C443.9,357.3,443.9,357.3,443.9,357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M444.1,360.9c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4 c0,0,0,0,0,0C443.9,360.5,444.1,360.6,444.1,360.9C444.1,360.9,444.1,360.9,444.1,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M444.3,364.5c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4 C444.1,364.1,444.3,364.3,444.3,364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M444.5,368.3c0,0.2-0.2,0.4-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.4-0.1-0.4-0.4c0,0,0,0,0,0c0-0.2,0.2-0.4,0.4-0.4 c0,0,0,0,0,0C444.3,367.9,444.5,368.1,444.5,368.3C444.5,368.3,444.5,368.3,444.5,368.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M456.2,367c-0.2-1.9-0.5-3.9-1.1-5.7c-0.2,0.2-0.4,0.4-0.5,0.6c-0.3,0.5-0.5,1.1-0.6,1.7 c-0.2,0.7-0.4,1.5-0.5,2.2c-0.4,1.7-0.9,3.5-2.3,4.6c-1,0.6-2.1,0.9-3.3,0.8c-1,0-2,0-3-0.2c-1.3-0.4-1.5-1.5-1.8-2.7 c-0.4-1.4-0.8-2.8-1.3-4.2c-0.2-0.7-0.5-1.4-1-1.9c-0.2-0.1-0.5-0.2-0.7-0.3c0,1.3-0.1,2.5-0.2,4c-0.5,5.5-0.6,9.8,2,13.9 c3.1,4.9,10.1,2,12.2-1.2S456.7,372.5,456.2,367z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "447.8,370.3 446,343.5 447.4,343.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M451.6,368.4L451.6,368.4c-2.5-0.7-5-0.7-7.4,0.1c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0c0-0.1,0-0.2,0.1-0.3 c2.5-0.8,5.1-0.9,7.6-0.1c0.1,0,0.2,0.1,0.1,0.2C451.8,368.3,451.7,368.4,451.6,368.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M451.4,364.5h-0.1c-2-1-5.3-0.8-7.3,0.1c-0.1,0-0.2,0-0.3-0.1c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0 c2.1-0.9,5.6-1.2,7.7-0.1c0.1,0,0.1,0.2,0.1,0.3C451.6,364.5,451.5,364.6,451.4,364.5L451.4,364.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M451.2,360.9h-0.1c-2-1-5.3-0.8-7.3,0.1c-0.1,0-0.2,0-0.3-0.1c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0 c2.1-0.9,5.6-1.2,7.7-0.1c0.1,0,0.1,0.2,0.1,0.3C451.4,360.9,451.3,361,451.2,360.9L451.2,360.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M451,357.4h-0.1c-2-1-5.3-0.8-7.3,0.1c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0,0,0,0,0.1,0 c2.1-0.9,5.6-1.2,7.7-0.1c0.1,0,0.1,0.2,0.1,0.3c0,0,0,0,0,0C451.1,357.4,451.1,357.4,451,357.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M448.2,191.3c1.2,3.9,2.6,18.5,3.1,24.6c2.3,25,2.5,60.3,2.5,60.3c0.3,2.6,1.6,5,2.3,17.6 c0.8,13.7-0.8,59.3-0.8,59.3s-10.5,4.4-16.6,0.5c0,0-8.8-54.5-10.8-68c-1.7-11.8-4.3-30.6-4.3-30.6l-3.2,29.7 c0,0,0.7,9.4,0.5,16.3c-0.3,8-5.1,43.1-5.1,43.1s-10.2,3.6-17.5-0.9c0,0-1.8-54.4-2.1-64c-0.6-18.9,0-60.9,0.5-81.2L448.2,191.3z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.7,255l-2.7-20.9c0,0-8.5-0.8-13.3-5c0,0,1.5,5,10.8,7.6l2.2,16.3l0.1,27.1L423.7,255z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M374.9,167.9c-7.6-5.5-9.8-7-10.7-9s-0.6-4.1-1.3-7.4c-0.5-2.8-0.5-5.7,0-8.6c0.5-1.7-1.6-1.5-3.3,0.6 s-1,3.3-1.5,5.3s-1.3,1.8-2.6,0.6s-7.1-7.5-9.2-9.3s-3.5-1.4-4.1-0.4c-0.3,0.5,0.8,1.6,3.4,4.5s5.3,5.2,5.1,5.4s-2.8-2.4-5.8-5 c-2.8-2.3-4.4-3.5-5.9-3.3c-1.8,0.2-1.9,1.5-1.4,1.9c2.3,1.7,4.4,3.5,6.5,5.5c1.2,1.1,2.4,2.2,3.4,3.4c-0.1,0.3-2.4-1.5-5.4-3.2 c-2.8-1.6-4.4-2.3-6-1.5c-0.3,0.2-0.8,0.7-0.7,1c0.3,0.7,2.6,1.8,3.9,2.7c2,1.3,2.2,1.3,3.6,2.4c1,0.7,2.3,1.7,2.2,1.9 s-5.1-2.2-6.8-2.2c-1.5,0-2.6,0.9-1.2,1.8s8.5,5.3,11.2,7.2s5.7,4.4,8.2,6.5s13.8,10.3,13.8,10.3L374.9,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M356.8,152.4c-1.4,2.4,0.2,6.3,2,8.4C356,158.9,354.3,155.8,356.8,152.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M408.6,165.2l1.4-25.3c-6.8,1.6-9.5,3.5-13.9,10.9c-2.4,4.1-8,13-13.1,21.1l-15.1-10.8 c0,0-6.5,5.7-7.8,11.5c0,0,17.9,15.7,21.8,18.5c3.6,2.5,6.3,4,11.4-1.8S407.3,167.5,408.6,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,171.9c3.2,2.2,6.4,6.4,6.9,9.6c0-4.5-2.2-8.6-5.9-11.2L383,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M418.4,137.4c2.3,0.2,15.7-0.4,19.2,0.7c2.9,0.9,6.3,1.7,8.8,2.6s2.3,2.8,2.5,6.6 c0.5,12.8-0.7,40.2-0.7,40.2l1.2,17.5c-6.1,6.2-37.7,11.3-52.6,1.7c0,0,0.6-32.7,2.1-48.6c1.3-13.1,7.1-16.6,11.6-18 C416.4,138.1,418.4,137.4,418.4,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M439,110.6c-1.8,8.5-11.2,13.8-20.9,11.7s-16.1-10.7-14.2-19.2s11.2-13.8,20.9-11.7S440.9,102,439,110.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M433.1,99.4c0,0,3.6,0.3,5,2.9c4,2.1,4.3,7.9,2,14.2c-2.1,5.9-3.7,6.9-4.8,8.5c-1.6,2.5-2.4,3.6-2.4,3.6 l-0.3-5.4l0.1-5c0,0-3.5-3.7-4.1-7.5c-0.5-2.6-0.4-5.2,0.3-7.7C429.5,101.3,430.9,99.3,433.1,99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M432.5,117.4c1.1,0.2,1.8-1.8,2.8-2.9c1.4-1.4,3.6-1.5,5-0.1c0.4,0.3,0.6,0.8,0.8,1.2 c1.7,3.4-0.3,6.8-3.1,8.2c-1.7,0.6-3.6,0.3-5-0.9l-0.3,13.6v0.2c-3,4-7.9,2.1-14.1,7.4c-0.4-1.6-0.5-3.3-0.3-4.9l-0.1-4.9 c0,0-4.2,0.5-6.8-0.4c-3.1-1.1-5-3.1-6.3-6.6c-1.4-3.7-1.8-13.4-0.5-20.3c1-5.4,2.4-6.7,6.4-7.6c5.4-1,10.9-0.7,16.1,1.1 c1.8,0.7,1.8,1.3,1.4,2.8C426.7,112,431.4,117.2,432.5,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M417.4,123.8c2.2-0.9,4.4,1.2,3.3,2c-0.5,0.3-1.5,0.1-2.3,0.4c-1,0.4-1.4,1.3-2.2,1.1 C415.2,127,415.2,124.7,417.4,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M417.3,126.9c0-1.5,1.2-2.6,2.6-2.6c0.2,0,0.4,0,0.6,0.1c0.5,0.5,0.6,1.1,0.1,1.4s-1.5,0.1-2.3,0.4 C418,126.3,417.6,126.6,417.3,126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M418.3,134.5c3-0.5,5.9-1.4,8.6-2.9c1.8-1.1,3.3-2.8,4.1-4.8c-0.1,1.8-0.7,3.5-1.8,4.9 c-1.9,2.4-10.9,4.9-10.9,4.9L418.3,134.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,114.5c0,0.8,0.7,1.4,1.5,1.4c0.8,0,1.4-0.7,1.4-1.5c0-0.8-0.7-1.4-1.5-1.4C420.2,113,419.6,113.7,419.6,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,109.4l3.1,1.6c0.4-0.9,0.1-2-0.8-2.4C421.5,108.2,420.5,108.5,420,109.4C420,109.4,420,109.4,420,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.1,107.7l-3.4,1.2c0.3,0.9,1.2,1.4,2.1,1.2c0,0,0,0,0.1,0C409.9,109.6,410.4,108.6,410.1,107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,113.8c0,0.8,0.7,1.4,1.5,1.4c0.8,0,1.4-0.7,1.4-1.5c0-0.8-0.7-1.4-1.5-1.4C407.6,112.2,407,112.9,407,113.8 C407,113.7,407,113.7,407,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M415.7,111.6l-1.4,10.3l-5.2-1.8C410.5,116.9,413.1,113.2,415.7,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416,146.7c-0.6-1.2-1-2.5-1-3.8l2-1.5l1.1,3.3L416,146.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M416,146.7c-0.6-1.2-1-2.5-1-3.8l2-1.5l1.1,3.3L416,146.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "419.8,144.8 424.8,141.1 428.8,144.2 421.1,148.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "419.8,144.8 424.8,141.1 428.8,144.2 421.1,148.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.5,150.6c-0.3,3.7,0.3,23.9,1.3,36.1c0.2,3-3.7,9.5-4.7,9.4s-3.4-5.6-3.9-9c-0.2-8.1,3-32.4,4.8-36.8 L419.5,150.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M416.7,150.7c0-0.1,0.1-0.2,0.1-0.4l2.6,0.2l-0.1,1.1C418.4,151.7,417.5,151.3,416.7,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M419.8,144.8c-0.6-0.1-1.1-0.2-1.7-0.2c-0.9,0.5-1.7,1.2-2.2,2.1c0,1.3,0.3,2.6,0.9,3.7 c0.8,0.5,1.7,0.5,2.6,0.2c0.9-0.6,1.5-1.5,1.9-2.5C421.3,146.8,420.7,145.6,419.8,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M432.9,132v1.3c-0.2,1-2.3,3.2-7.3,5.6s-6.9,5.5-6.9,5.5s2-1.6,3.6,0c2.2,2.2,3.3,4.1,4.4,4.1 s6.4-2.7,8.8-6c1-1.3,1.8-2.8,2.4-4.3C434.4,136,434.2,132,432.9,132z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M418.6,144.3c-1.8-1.3-4,2.3-4.5,1.7s1.4-8.4,4.1-10.2L418.6,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M434.9,134.8c-0.3,4.4-19.5,46.1-19.5,46.1s-6.2-23.7,1.2-43.2c-2.3,0.5-4.4,1.2-6.5,2.2 c-4.6,1.9-10.6,5.2-12.3,17.7s-2,63.6-2,63.6c15.3,6.6,32.4,7.6,48.5,3l0.7-8.4l1.9,7.3c1.9-0.4,3.7-1.2,5.3-2.3 c-1-12-1.6-34.7-1.6-42.4c-0.1-8.7,0.1-25.8-0.1-31.1s-0.5-5.6-4.4-7.1S438.2,138.1,434.9,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M417.6,136.3c-0.9,0.7-1.9,1.4-3,1.9c0,0-5.1,8.5-7,14s-2,6.4,2.9,6.6c-2.8,1.5-3.5,1.4-0.9,10.3 c1.4,4.9,3.3,9.7,5.8,14.1l0.2-2c0,0-2.4-12.6-2.3-22.3C413.4,143.9,417.6,136.3,417.6,136.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M434.4,133.9c0.4,0.8,3.3,3.1,6.2,4.4c-1,5.6-2.8,14.6-4.7,18.5s-4.4,3-7.5,2.6c1.5,3.6,3.5,3.9-1.2,9.5 c-6.7,7.9-12.8,13-14.3,21.2c0.2-8.8,4-15.3,5.9-21s6-12.9,9.8-20.8C430.9,143.7,432.9,138.9,434.4,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M446,140.2c8.5,1.2,12.7,3.8,15.1,9.9s6.4,21,8.5,30c1.8,7.7,2.6,14.7,0.7,18l-16.3-7l-7.6-24.4 C446.5,166.7,440.3,148,446,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.6,179.2c1.4,1.9,3,2.7,6.4,4.4c3.2,1.6,7,3,8.9,6.6c-0.5-3.3-2.3-4.9-6.3-7.2s-9.9-5.1-9.9-5.1L452.6,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M452.6,179.2c1.4,1.9,3,2.7,6.4,4.4c3.2,1.6,7,3,8.9,6.6c1.7,3.1,3.5,5.7,2.4,8c-0.8,1.6-5.4,2.5-9.6,2.2 s-7.2-3.9-11.5-7c-3.7-2.7-5.6-4.4-5.6-4.4L452.6,179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M446.9,182.1c1.6-1.4,2-3,4.3-4.1s3.8-1,6.2-2.1s4.5-1.6,6.2-0.9s1.4,1.7,0,2.5s-3.8,1.8-5.5,2.8 s-3.3,1.7-3.5,3.7c-0.1,3.3-0.1,6.5,0.1,9.8c0.2,3.5,0.7,6.3,0.5,6.6s-1.8,0.4-2.6-1.5s-1.5-9.1-1.5-9.1s-1,4.8-1.5,8.1 s-0.8,5.9-0.9,6.6s-2.5,0-2.7-2.5s0.7-10,0.7-10l-3.6,5.4c-1.4,2.1-3.2,5.1-3.7,5.8s-2-0.7-1.5-2.7s3.4-6.7,3.4-6.7 s-3.3,3.1-3.9,3.3s-2.2-0.1-1.5-2.3c0.5-1.4,1.5-2.3,4.2-5.1s2.7-3.9,3.6-5.1C444.9,183.1,445.7,183.1,446.9,182.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M453,183.7c-2.6,0.9-4.9-0.3-5.2-1C447.8,184.4,451.2,185.6,453,183.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M435.9,196.2c0.4,0.4,1.1,0.4,1.6,0c1.1-0.9,2.1-1.9,3.1-2.9c0.8-0.8,3.3-3.4,3.3-3.4l-2.5,4 c0,0-3.3,3.1-3.9,3.3c-0.6,0.2-1.3-0.1-1.6-0.7C435.9,196.4,435.9,196.3,435.9,196.2z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M50,344.5c-0.3,2-1,4.3-1.5,8.3s0.4,4.2-2,14.4c-1.5,6.1-0.9,7.8,2.2,13.3c3.4,5.9,9.2,4.5,11.8-1.7 c2.2-5.2,1.6-7.7,1.5-13s-0.1-7,0.1-11.2c0.1-3.8-0.2-6.3,0-9.2L50,344.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M49.1,359.3c0.6-5.2,0.7-10.6,0.9-14.2c0.4-7.9-1.5-23.5-0.6-35.4l20-2.4c-0.6,4.7-5.7,25.7-7.4,38.4 c0,0-0.4,17.2-1.4,24.8c-0.1,0.8-0.8,1.4-1.6,1.3c-0.1,0-0.3-0.1-0.4-0.1c-2.9-1.2-6.1-1.4-9.1-0.4c-0.7,0.3-1.6-0.1-1.9-0.8 c-0.1-0.2-0.1-0.3-0.1-0.5C47.5,367.1,48.6,363.3,49.1,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M107.3,306.1c-0.1,16.5-0.7,29.2-0.1,33.5c0.5,3.6,1.4,7.1,2.7,10.5c1.1,3,2.9,7,4.6,8.9c0,0,4.7,5,3.7,5.5 s-10.9,1.5-15.3,0.2s-4.9-5.1-6.4-11.9S93.7,336,93.7,336c0.2-0.4,0.4-0.8,0.5-1.2c0.6-2-1.2-7.1-1.7-12L107.3,306.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M89.7,346c0.1,2.2,1.5,3.5,2,6c0.6,2.9,0.9,5.8,0.9,8.7c0,3.6,0,4.1,0,4.1h1.1c0,0,0-5.1-0.1-7.4 s0.2-3.9,1.3-4.2C94.9,353.2,95.1,346,89.7,346z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M93.3,335.4c-0.7,2.1-1.6,4.1-2.6,6c-0.6,1.1-0.9,2.3-1,3.5c-0.1,1.1,0.3,2.2,1.1,2.9 c0.9,0.9,1.8,1.8,2.5,2.9c1.3,1.8,3.9,6,4.6,9s1.1,5.6,3.7,7.1c2,1.2,10.2,2.8,14.3,3c5.7,0.4,7.1-2.4,5-4.5s-5.7-5.9-6.4-6.4 c-1.8-0.2-3.6,0-5.3,0.7c-3.2,1.4-4.2,3.2-7.5,1.5c-3-1.5-3.8-7.1-4-15.1C97.5,333.7,93.3,335.4,93.3,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M59.2,193.7c-0.4,2.4-1.2,4.7-2.3,6.8c-3.6,6.9-6.6,11.6-6.6,24.1c-0.1,28.4,0.9,55.7,0.9,55.7 c-0.2,2.5-2.1,8.6-2.4,22.9c-0.2,11.4,0.3,41.4,0.3,41.4s6.8,3.9,13.9,1.2c1.9-11.7,9.1-49.2,11.8-61.7 c2.9-13.1,5.8-28.7,5.8-28.7l4.9,22.9c-0.5,4.9-0.4,9.9,0.2,14.8c0.9,7.6,6.7,43.9,6.7,43.9s7.9,2.8,15.5-1.2 c0,0,0-47.8,0.5-56.1c0.5-8.1-2.6-65.9-5.2-85.6C93.9,199.2,67.2,199.1,59.2,193.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5,255.3l2.6-23.9c0,0,9.8-0.6,16.2-6.9c0,0-2.8,7.4-13.2,10l-3.4,22l2.7,21.6L80.5,255.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M163.7,137.4c-0.9-0.2-1.8-0.1-2.6,0.2c-1.3,0.6-2.5,1.3-3.7,2.1c-1.9,1-5,2.7-7.1,2.6 c-0.4,0-1.4-0.2-0.8-0.8c0.8-0.7,1.6-1.4,2.3-2.2c0.7-0.8,1-1.9,0.9-3c0-0.3-0.2-0.6-0.4-0.8c-0.4-0.3-0.6-0.1-0.9,0.1 c-0.3,0.2-0.7,0.4-1,0.6l-2.1,1.2c-4,2.3-8,5.1-10.4,9.2c-0.4,0.6-2.4,5.3-3.7,7.9c-1.1,2.4-9.3,17.5-9.3,17.5l-14.7-14.3 c-3.3-3.3-6.6-6.3-9.5-7.4c-2.1-0.8-5-1.9-5-1.9l5.3,25.1c0,0,15.5,11.6,17.7,13.2c3.3,2.4,9.8,6.2,13.1,2.2 c4.4-5.4,6.6-13.3,8.6-19.3s3.2-9.6,4.3-11.7s3.1-2.2,4.5-2.6c1.9-0.5,3.7-1.3,5.4-2.4c1.5-0.8,2.9-1.8,4.1-3 c0.7-0.5,1.2-1.2,1.6-1.9c0.1-0.7,0.2-1.3,0.4-2c0.5-0.7,0.9-1.4,1.2-2.1c0.1-0.6,0.2-1.3,0.1-1.9c0.1-0.9,0.6-1.7,1.4-2.2 c0.4-0.3,0.7-0.6,0.9-1.1C164.8,137.9,164.3,137.5,163.7,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.2,159.9l2-3.4c0.8,2,2.3,3.7,4.2,4.9c3.3,2.2,5.5,1.4,5.5,1.4l-1.2,4.1c0,0-2.5,0.9-6.4-1.7 S131.2,159.9,131.2,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.2,147.8c2.7,0.7,5.4,1,8.7,3.5c3.5,2.7,20.9,18.1,20.9,18.1l7.1-10.9c0,0,0.4,3,4.5,5.4 c4.4,2.5,5.9,1.7,5.9,1.7s-3.2,13-6.8,19.3s-5.6,8.4-11.4,5.8s-25.6-17.4-25.6-17.4L95.2,147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M147.8,144.2c-1,2.5-2.7,4.6-4.9,6.2c1.4-0.2,2.7-0.8,3.6-1.9C147.5,147.3,148,145.7,147.8,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8,169.3c-2.5,4.3-3.2,9.8-2.7,12.6c-2-4.6-1.6-9.9,1.2-14.1L124.8,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.2,146.8c-5.2,2-8.2,3.1-8.2,3.1c-1.1,2.8-3.3,9.6-2.1,17.1s5.1,23.5,4.3,26.7s-6.5,12.9-8,22.3 c1.8,1.7,3.8,3.1,5.9,4.3c0,0,2.2-9.1,3.7-13.4c0,7.8-0.1,14.1-0.1,14.1s7.3,4.8,31.4,2.5c12.9-1.2,15.2-6.3,15.2-6.3 s-2.6-21-2.6-25.9v-13.2c2.7-2.9,3.9-6.8,3.4-10.8c-0.6-7-9.6-17.4-11.9-19.7c-1.9-0.8-10.4-3.6-10.4-3.6L64.2,146.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.4,146.4c0.7,3.7,2.2,4.6,6.4,9.1s17.2,17,18.4,22.5c0.8-4.6,1.8-10.9,0.6-16.3s-4.2-12.6-8.9-16.3 l-16.1-0.7L69.4,146.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.8,118.5c3.9-14.4-9.3-21.7-22.5-19.4c-4.3,0.8-9.9,3.2-10.5,9.4c-5.7,1.8-8.5,9.5-5,17.7 c2.6,6,7.7,8.9,10,12.6L97.8,118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M64.5,120.6c3.7-1.6,5.5,2.2,5.5,2.2c2.4,1.5,3.8-3.3,4.3-4.8c0.9-2.5,1.8-6.1,4.6-7.2 c2.1-0.8,4.4,0,6.3,1.1c1.1,0.7,2.5,0.9,3.8,0.5c1.1-0.3,1.5-2.1,2.5-2.7c3-1.6,5,3.4,5.7,5.7c0.8,2.9,1.1,5.9,0.9,8.9 c-0.2,10.7-4,15.7-5.8,16.7s-4.1,1.2-7.6,1v3.2c1.6,3.5,2.4,7.2,2.6,11c-7.9-2.6-12.6-6.2-17.6-10.9v-14.4 c-0.7,1.4-3.8,2.1-5.8-0.4C61.5,127.3,61,122.1,64.5,120.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M84.8,142.1c-3.5-0.5-9.8-2.2-10.8-5.1c0,0-0.2,2.3,2.5,4.4c2.2,1.7,8.4,2.8,8.4,2.8L84.8,142.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.3,116.5l-3.3,1.8c-0.5-0.8-0.2-1.9,0.6-2.4c0,0,0.1,0,0.1-0.1C93.7,115.3,94.8,115.6,95.3,116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M81.2,117.6l3.6,1.1c0.3-0.9-0.1-1.9-1.1-2.3c0,0-0.1,0-0.1,0C82.6,116.1,81.5,116.6,81.2,117.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M95.4,122.6c0.1,0.8-0.5,1.6-1.4,1.7c0,0,0,0-0.1,0c-0.8,0-1.6-0.6-1.6-1.4c-0.1-0.8,0.5-1.6,1.4-1.7 c0,0,0,0,0,0C94.6,121.1,95.4,121.7,95.4,122.6C95.4,122.6,95.4,122.6,95.4,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84,123.4c0.1,0.8-0.5,1.6-1.4,1.7c0,0,0,0,0,0c-0.9,0.1-1.6-0.5-1.7-1.4c-0.1-0.9,0.5-1.6,1.4-1.7 C83.1,121.9,83.9,122.5,84,123.4C84,123.4,84,123.4,84,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M80.5,122.7c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.3-0.1-0.5-0.2l-0.6-0.2l-0.6-0.2l-0.3-0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.3,0.3l0.3,0.1h0.2h0.1l0,0h0.2l0.6,0.2c0.2,0.1,0.5,0.2,0.8,0.3 c0.1,0,0.3,0,0.4-0.1C80.5,122.9,80.5,122.8,80.5,122.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M80.4,123.9c-0.1-0.2-0.3-0.3-0.6-0.3c-0.3-0.1-0.6-0.1-0.9-0.1c-0.4,0-0.7,0-1.1,0.1s-0.1,0.6,0.1,0.6 c0.4,0,0.9,0,1.3,0c0.2,0,0.4,0,0.5,0h0.2h0.2c0.1,0,0.1,0,0.2-0.1C80.4,124,80.4,123.9,80.4,123.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M80.3,124.6c-0.1-0.1-0.2-0.1-0.3,0l-0.2,0.1l-0.5,0.2l-0.4,0.1h-0.2l-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.2v0.1 c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1,0,0.2,0h0.1c0.1,0,0.1,0,0.2,0l0.2-0.1c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.6-0.3 c0.1,0,0.1-0.1,0.1-0.2C80.4,124.8,80.4,124.7,80.3,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M101.3,117.7h-0.7c-2.4-0.2-4.9,0.1-7.2,0.8c-2.3,0.9-3.2,1.7-4.4,1.8s-2.2-0.6-4.6-1.2 c-2.6-0.3-5.2-0.2-7.7,0.3l-0.8,0.1c-0.6,0.2-0.9,0.8-0.9,1.4c0.1,0.5,0.3,1.1,0.7,1.5c0.1,0.2,0.2,0.4,0.2,0.6 c0.2,1.4,0.4,2.8,0.8,4.1c0.2,0.5,0.5,1,0.9,1.4c0.1,0.1,0.3,0.3,0.5,0.4c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.1,0.6,0.3,0.8,0.4h0.2 l0.2,0.1h0.2c0.3,0,0.5,0.1,0.8,0.1h0.3h0.4c2.3,0,4.4-1.4,5.4-3.5c0.8-1.6,0.7-3.9,2.2-4h0.3c1.1,0.2,0.9,2.2,1.5,3.7 c0.2,0.6,0.6,1.1,1,1.5c0.1,0.1,0.2,0.2,0.2,0.2l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1l0.1,0.1h0.1c0.4,0.2,0.8,0.3,1.2,0.4h0.1 c0.5,0.1,1,0.1,1.5,0.1c2-0.1,3.8-1.3,4.6-3.2c0.4-1.4,0.8-2.8,1-4.2c0.1-0.2,0.1-0.4,0.3-0.6c0.4-0.4,0.6-0.9,0.7-1.5 C102.1,118.3,101.7,117.8,101.3,117.7z M85.9,124.7c-0.2,0.8-0.6,1.6-1.2,2.3l0,0c-0.9,1-2.2,1.5-3.5,1.5 c-1.2,0.2-2.5-0.3-3.2-1.3l-0.1-0.2c0,0-0.1-0.1-0.1-0.2l-0.1-0.1l-0.1-0.1v-0.1v-0.1l-0.1-0.2l0,0c-0.1-0.2-0.1-0.3-0.2-0.4 l0,0c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0,0-0.1v-0.1c-0.2-1.1-0.4-3.2,0.1-3.8s2-1.1,4.4-1.1h0.2 c0.4,0,0.7,0,1.1,0.1l0.4,0.1c0.4,0.1,0.7,0.2,1,0.3l0.3,0.1l0.3,0.1h0.1l0.1,0.1c0.3,0.1,0.5,0.3,0.7,0.5 C86.4,122.1,86.2,123.5,85.9,124.7L85.9,124.7z M99.7,123.3c-0.2,1.5-1.1,2.9-2.4,3.7c-0.5,0.3-1.1,0.5-1.8,0.5 c-1.3,0.3-2.7-0.3-3.5-1.4l0,0c0,0-0.1-0.1-0.1-0.1l-0.1-0.1v-0.1c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.2v-0.1c0,0,0,0,0-0.1v-0.1 c0,0,0,0,0-0.1c-0.1-0.3-0.2-0.5-0.2-0.8c-0.3-1.1-0.2-2.3,0.2-3.4c0.5-0.7,2.2-1.6,3.9-1.9c0.4-0.1,0.8-0.1,1.1-0.2H98 c0.2,0,0.4,0,0.5,0.1h0.1l0,0h0.1h0.1H99c0.1,0,0.2,0.1,0.2,0.1l0,0c0.2,0.1,0.4,0.2,0.6,0.3C100.3,120,99.9,122.2,99.7,123.3 L99.7,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75.7,119.8l-7.3,1.3c0.6,0.4,1,0.9,1.4,1.5l5.9-1L75.7,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M88.2,122.4l1,8.7l5.1-1.8l-5.6-7.1C88.6,122.2,88.4,122.3,88.2,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M68.4,129.3c0,0.8-0.6,1.4-1.3,1.4c-0.8,0-1.4-0.6-1.4-1.3c0-0.8,0.6-1.4,1.3-1.4c0,0,0,0,0,0 C67.8,128,68.4,128.6,68.4,129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.7,132.6c-2.2-0.9-4.4,1.2-3.3,2c0.5,0.4,1.5,0.1,2.3,0.4c1,0.4,1.4,1.3,2.2,1.1 C89.9,135.8,89.9,133.5,87.7,132.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.8,135.7c0-1.4-1.2-2.6-2.6-2.6c-0.2,0-0.5,0-0.7,0.1c-0.5,0.5-0.6,1.1-0.1,1.4s1.5,0.1,2.3,0.4 C87.1,135.2,87.5,135.4,87.8,135.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M69.8,143.1v1.6c3,4.1,6.1,8.1,9.5,11.9c6.3,7,11.7,12.3,13.7,17.1c1.3,3.5,2.2,7.1,2.7,10.9 c-1.6-5.5-4.9-10.4-9.4-13.9c-4.6-3.7-12-6.5-13.4-8.8s1.3-5.2,1.3-5.2c-2.6-0.8-5-2-7.3-3.4c-2.8-2-2.8-6.3-2.8-6.3L69.8,143.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.8,145.3c3.9,4,6.6,8.9,7.8,14.4c1.2,6.2,1.7,20.3,1.7,20.3s1.6-9.5,2.5-13.6s1.4-7.2-3.1-11.3 c1.1-1.9,1.3-2.6-1-5.4c-1.2-1.5-2.7-2.9-4.3-4l-3.6-2.3L84.8,145.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M94.5,197.1c2.4-0.2,4.7-2.5,7.8-3.7s5.8-1.2,7.9-2.1c0.9,0.5,0.4,2.4-0.6,3.1c-1.6,1.2-4.1,2-3.5,2.7 c0.9,1,4.2,0.3,5.2,0.1c3.1-0.6,6.5-2.5,9.7-1.8c0.3,0,0.7,0.2,0.9,0.5c0.2,0.4,0.1,1-0.2,1.3c-0.4,0.3-0.8,0.6-1.2,0.8 c-0.4,0.2-0.7,0.7-0.8,1.1c0,0.4,0.2,0.9,0.2,1.3c-0.1,0.3-0.2,0.5-0.4,0.8c-0.3,0.4-0.7,0.8-1.2,1.1c-0.4,0.2-0.7,0.5-1.1,0.7 c-0.7,0.5-1.3,1.2-1.9,1.9c-1.7,2.8-5.4,3.6-8.4,4.1c-6.4,1.1-9.3-0.2-13.1-0.2s-19.8-0.4-28-1c-8.6-0.6-9.7-2.2-12.1-10.4 c-2.8-9.6-4.9-19.4-6.5-29.3c-1.4-10.3,0-15.6,10.2-18.9c2.9,1.9,6.4,9,8.1,22.7l3.7,20.6C69.4,192.7,92.1,197.4,94.5,197.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.4,196.1l4,0.9c-0.4,2-0.7,4.1-0.7,6.2c-0.1,2,0.1,3.9,0.6,5.9l-4.9,0.1 C87.4,209.1,84.7,201.6,88.4,196.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M58.7,149c-4.6,0.9-8.8,2.2-11.2,5.9s-1.5,7.8-0.5,15.5s6.3,27.8,7.6,32.1s2.1,5.2,6.7,6s27.9,1,27.9,1 c-0.6-2.3-0.8-4.7-0.5-7c0.1-2.2,0.5-4.3,1.2-6.4l-20.2-3.7c0,0-3.2-19.3-4.3-25.3S62.9,154.5,58.7,149z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7,192.4c-2.8-0.3-7.5,1.6-8.8,4.1c0.6-2.7,3.5-5.7,8.6-5.7L69.7,192.4z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Podium--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "352.6,428.6 352.6,416.7 293.3,382.4 293.3,394.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "352.6,416.7 412,382.4 412,394.3 352.6,428.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "352.6,416.7 412,382.4 352.6,348.2 293.3,382.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "352.6,411.8 301.8,382.4 296,262.4 352.6,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "352.6,411.8 403.5,382.4 409.2,262.4 352.6,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "352.6,295 352.6,287.3 290.9,251.7 290.9,259.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "352.6,287.3 414.4,251.7 414.4,259.4 352.6,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "296.5,273.1 296,262.4 352.6,295 409.2,262.4 408.7,273.1 352.6,305.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "352.6,287.3 414.4,251.7 352.6,216 290.9,251.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "342.3,310.1 306.3,289.3 309.7,375.1 342.3,394  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M311.5,298.1l25.7,14.9v72.2l-22.5-13L311.5,298.1 M310.1,295.9l3.4,77l25,14.5v-75.1L310.1,295.9 L310.1,295.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Garland--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.6,287.3v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L352.6,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M352.6,287.3v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L352.6,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M340.3,280.2v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L340.3,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.9,273.1v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L327.9,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M327.9,273.1v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L327.9,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.6,265.9v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L315.6,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.2,258.8v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L303.2,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.2,258.8v9.2c0,3.9-6.2,8.2-6.2,8.2s-6.2-11.4-6.2-15.4v-9.2L303.2,258.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microphone--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M303.5,248.6c0-1.4,0.9-2.8,2.8-3.8c4.2-2.1,9.1-2.1,13.3,0c1.8,1.1,2.8,2.4,2.8,3.8v1.6 c0,1.4-0.9,2.8-2.8,3.8c-4.2,2.1-9.1,2.1-13.3,0c-1.8-1.1-2.8-2.4-2.8-3.8V248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M303.5,248.6c0-1.4,0.9-2.8,2.8-3.8c4.2-2.1,9.1-2.1,13.3,0c1.8,1.1,2.8,2.4,2.8,3.8v1.6 c0,1.4-0.9,2.8-2.8,3.8c-4.2,2.1-9.1,2.1-13.3,0c-1.8-1.1-2.8-2.4-2.8-3.8V248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M319.6,252.4c-4.2,2.1-9.1,2.1-13.3,0c-1.8-1.1-2.8-2.4-2.8-3.9s0.9-2.8,2.8-3.8c4.2-2.1,9.1-2.1,13.3,0 c1.8,1.1,2.8,2.4,2.8,3.8S321.4,251.4,319.6,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M327.9,200.1c2.3-3.3,6.9-4.1,10.3-1.8s4.1,6.9,1.8,10.3c-0.1,0.1-0.1,0.2-0.2,0.2l-4.8,6.6 c-2.5,3.2-7.1,3.8-10.3,1.4c-3.1-2.4-3.8-6.8-1.6-10.1L327.9,200.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M324.6,216.9c-2.4-1.8-3.5-4.8-2.8-7.7c1.2,0.7,7.5,4.3,8.4,4.8s3.5-1.9,6.2-5.9s4.4-5.8,2.8-8.6 c2.3,2.6,2.5,6.4,0.4,9.2l-4.8,6.6C332.5,218.6,327.9,219.3,324.6,216.9C324.7,216.9,324.6,216.9,324.6,216.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.7,214 321.6,222.3 324.8,228.6 330.8,220.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "327.7,214 321.6,222.3 324.8,228.6 330.8,220.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "321.6,222.3 313.9,217.8 320,209.5 327.7,214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "324.8,228.6 317,224.1 313.9,217.8 321.6,222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "324.8,228.6 317,224.1 313.9,217.8 321.6,222.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M311.8,248.6c0,0.7,2.2,0.7,2.2,0c0-8.2,0-17.6,5.8-24.6c0.5-0.6-1.2-2-1.7-1.4 C311.8,230.2,311.8,240.4,311.8,248.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Name--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "356.9,277.2 361.1,274.8 331.4,257.6 327.2,260.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "356.9,277.2 327.2,260.1 328.6,251.1 358.3,268.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.5,271.3v0.2c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.3-0.1-0.4-0.2l-18.7-10.8c-0.6-0.4-1-1.1-0.9-1.8v-0.2 c0-0.4,0.4-0.8,0.8-0.8c0.2,0,0.3,0.1,0.4,0.2l18.7,10.8C355.2,269.9,355.6,270.6,355.5,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M333.8,258.7v0.2c0,0.4-0.4,0.8-0.8,0.8c-0.2,0-0.3-0.1-0.4-0.2l-2.1-1.2c-0.6-0.4-1-1.1-0.9-1.8v-0.2 c0-0.4,0.4-0.8,0.8-0.8c0.2,0,0.3,0.1,0.4,0.2l2.1,1.2C333.5,257.3,333.9,258,333.8,258.7z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-3_00000142865324805537826370000000447805554373130673_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--podium--inject-3_00000078020393790685483530000012333975701690708652_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "149.5,428.6 149.5,416.7 208.9,382.4 208.9,394.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "149.5,416.7 90.2,382.4 90.2,394.3 149.5,428.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "149.5,416.7 90.2,382.4 149.5,348.2 208.9,382.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "149.5,411.8 200.4,382.4 206.1,262.4 149.5,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "149.5,411.8 98.7,382.4 92.9,262.4 149.5,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "149.5,295 149.5,287.3 211.3,251.7 211.3,259.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "149.5,287.3 87.8,251.7 87.8,259.4 149.5,295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "205.6,273.1 206.1,262.4 149.5,295 92.9,262.4 93.4,273.1 149.5,305.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "149.5,287.3 87.8,251.7 149.5,216 211.3,251.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "159.8,310.1 195.8,289.3 192.4,375.1 159.8,394  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M190.6,298.1l-3.2,74l-22.5,13.1V313L190.6,298.1 M192,295.9l-28.4,16.4v75.1l25-14.5L192,295.9L192,295.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--garland--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.5,287.3v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L149.5,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.9,280.2v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L161.9,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M161.9,280.2v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L161.9,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.2,273.1v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L174.2,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.6,265.9v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L186.6,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.6,265.9v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L186.6,265.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.9,258.8v9.2c0,3.9,2.8,5.5,6.2,3.6c3.6-2.4,5.9-6.3,6.2-10.7v-9.2L198.9,258.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--microphone--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M198.7,248.6c0-1.4-0.9-2.8-2.8-3.8c-4.2-2.1-9.1-2.1-13.3,0c-1.8,1.1-2.8,2.4-2.8,3.8v1.6 c0,1.4,0.9,2.8,2.8,3.8c4.2,2.1,9.1,2.1,13.3,0c1.8-1.1,2.8-2.4,2.8-3.8V248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.7,248.6c0-1.4-0.9-2.8-2.8-3.8c-4.2-2.1-9.1-2.1-13.3,0c-1.8,1.1-2.8,2.4-2.8,3.8v1.6 c0,1.4,0.9,2.8,2.8,3.8c4.2,2.1,9.1,2.1,13.3,0c1.8-1.1,2.8-2.4,2.8-3.8V248.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.6,252.4c4.2,2.1,9.1,2.1,13.3,0c1.8-1.1,2.8-2.4,2.8-3.9s-0.9-2.8-2.8-3.8c-4.2-2.1-9.1-2.1-13.3,0 c-1.8,1.1-2.8,2.4-2.8,3.8S180.8,251.4,182.6,252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.3,200.1c-2.3-3.3-6.9-4.1-10.3-1.8c-3.3,2.3-4.1,6.9-1.8,10.3c0.1,0.1,0.1,0.2,0.2,0.2l4.8,6.6 c2.5,3.2,7.1,3.8,10.3,1.4c3.1-2.4,3.8-6.8,1.6-10.1L174.3,200.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M177.5,216.9c2.4-1.8,3.5-4.8,2.8-7.7c-1.2,0.7-7.4,4.3-8.4,4.8s-3.5-1.9-6.2-5.9s-4.4-5.8-2.8-8.6 c-2.3,2.6-2.5,6.4-0.4,9.2l4.8,6.6C169.6,218.6,174.2,219.3,177.5,216.9C177.5,216.9,177.5,216.9,177.5,216.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "174.5,214 180.5,222.3 177.4,228.6 171.3,220.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "174.5,214 180.5,222.3 177.4,228.6 171.3,220.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "180.5,222.3 188.2,217.8 182.2,209.5 174.5,214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "177.4,228.6 185.1,224.1 188.2,217.8 180.5,222.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "177.4,228.6 185.1,224.1 188.2,217.8 180.5,222.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M190.4,248.6c0,0.7-2.2,0.7-2.2,0c0-8.2,0-17.6-5.8-24.6c-0.5-0.6,1.2-2,1.7-1.4 C190.4,230.2,190.4,240.4,190.4,248.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--name--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "145.3,277.2 141,274.8 170.7,257.6 174.9,260.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "145.3,277.2 174.9,260.1 173.5,251.1 143.9,268.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M151.7,268.4v0.2c0,0.4,0.4,0.8,0.8,0.8c0.2,0,0.3-0.1,0.4-0.2l18.7-10.8c0.6-0.4,1-1.1,0.9-1.8v-0.2 c0-0.4-0.4-0.8-0.8-0.8c-0.2,0-0.3,0.1-0.4,0.2l-18.7,10.8C152,266.9,151.6,267.6,151.7,268.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M146.6,271.3v0.2c0,0.4,0.4,0.8,0.8,0.8c0.2,0,0.3-0.1,0.4-0.2l2.1-1.2c0.6-0.4,1-1.1,0.9-1.8v-0.2 c0-0.4-0.4-0.8-0.8-0.8c-0.2,0-0.3,0.1-0.4,0.2l-2.1,1.2C146.9,269.8,146.6,270.5,146.6,271.3z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3_00000067933444415717305490000002622948062420634046_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166,67.3l-39.6,22.8c-0.6,0.4-1.1,1.1-1.1,1.9v35c0,0.8,0.4,1.5,1.1,1.9l3.9,2.2c0.7,0.3,1.5,0.3,2.2,0 l39.5-22.8c0.6-0.4,1.1-1.1,1.1-1.9v-35c0-0.8-0.4-1.5-1.1-1.9l-3.9-2.2C167.5,67,166.7,67,166,67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.5,130.5v-35c0-0.8,0.5-1.5,1.1-1.9l39.5-22.8c0.6-0.3,1.1-0.1,1.1,0.6v35c0,0.8-0.5,1.5-1.1,1.9 l-39.5,22.8C132,131.5,131.5,131.2,131.5,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M132.6,131.2c-0.7,0.3-1.5,0.3-2.2,0l-3.9-2.2c-0.6-0.4-1.1-1.1-1.1-1.9v-35c0-0.4,0.1-0.8,0.3-1.1l6.1,3.5 c-0.2,0.3-0.3,0.7-0.3,1.1v35C131.5,131.2,131.9,131.5,132.6,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M173.2,71.2c-0.1-0.6-0.5-0.8-1.1-0.4l-39.5,22.8c-0.3,0.2-0.6,0.5-0.8,0.8l-6.1-3.5 c0.2-0.3,0.4-0.6,0.8-0.8L166,67.3c0.7-0.3,1.5-0.3,2.2,0l3.9,2.2C172.7,69.9,173.1,70.6,173.2,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.3,99.1l-7.6,8.4c-0.4,0.4-0.3,1,0.1,1.4c0,0,0.1,0.1,0.1,0.1c0.2,0.1,6.1,3.5,6.1,3.5l7.4-9.9 L125.3,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M125.3,99.1l-7.6,8.4c-0.4,0.4-0.3,1,0.1,1.4c0,0,0.1,0.1,0.1,0.1c0.2,0.1,6.1,3.5,6.1,3.5l7.4-9.9 L125.3,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.5,102.6l-7.6,8.4c-0.4,0.4-0.3,1,0.1,1.4c0.2,0.2,0.5,0.3,0.7,0.2l6.7-0.6 C132.4,112.1,132.4,102.6,131.5,102.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.3,113v3.6c-0.1,0.9-0.7,1.8-1.5,2.1l-0.8,0.5c-1.1,0.6-1.5,0.4-1.5-0.4v-3.6c0.1-0.9,0.6-1.8,1.5-2.1 l0.8-0.5C145.8,112.1,146.3,112.2,146.3,113z M147.1,91c-0.4,5.7-0.8,11.4-1.3,17.1c0,0.9-0.5,1.7-1.3,2l-0.3,0.2 c-1,0.6-1.3,0.3-1.3-0.5V93.6c0.1-0.9,0.6-1.8,1.5-2.1l1.1-0.6C146.6,90.2,147.1,90.3,147.1,91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M154.4,108.4v3.6c-0.1,0.9-0.6,1.8-1.5,2.1l-0.8,0.5c-1.1,0.6-1.5,0.4-1.5-0.4v-3.6c0.1-0.9,0.7-1.8,1.5-2.1 l0.8-0.5C153.9,107.4,154.4,107.6,154.4,108.4z M155.2,86.4c-0.4,5.7-0.8,11.4-1.3,17.1c0,0.9-0.5,1.7-1.3,2l-0.3,0.2 c-1.1,0.6-1.3,0.3-1.3-0.5V88.9c0.1-0.9,0.6-1.8,1.5-2.1l1.1-0.6C154.6,85.6,155.2,85.7,155.2,86.4L155.2,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M162.5,103.7v3.6c-0.1,0.9-0.7,1.8-1.5,2.1l-0.8,0.5c-1.1,0.6-1.5,0.4-1.5-0.4v-3.6c0.1-0.9,0.6-1.8,1.5-2.1 l0.8-0.5C162,102.7,162.5,102.9,162.5,103.7z M163.3,81.7c-0.4,5.7-0.8,11.4-1.3,17.1c0,0.9-0.5,1.7-1.3,2l-0.3,0.2 c-1,0.6-1.3,0.3-1.3-0.5V84.2c0.1-0.9,0.6-1.8,1.5-2.1l1.1-0.6C162.7,80.9,163.3,81,163.3,81.7L163.3,81.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3_00000072970596334907352420000002621568574016870817_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3_00000176738398380960819970000005960417266696178326_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.2,67.3l39.5,22.8c0.6,0.4,1.1,1.1,1.1,1.9v35c0,0.8-0.5,1.5-1.1,1.9l-3.9,2.2c-0.7,0.3-1.5,0.3-2.2,0 L333,108.3c-0.6-0.4-1.1-1.1-1.1-1.9v-35c0-0.8,0.5-1.5,1.1-1.9l3.9-2.2C337.6,67,338.5,67,339.2,67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.6,130.5v-35c0-0.8-0.5-1.5-1.1-1.9L333,70.8c-0.6-0.3-1.1-0.1-1.1,0.6v35c0,0.8,0.5,1.5,1.1,1.9 l39.5,22.8C373.2,131.5,373.6,131.2,373.6,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M372.5,131.2c0.7,0.3,1.5,0.3,2.2,0l3.9-2.2c0.7-0.4,1.1-1.1,1.1-1.9v-35c0-0.4-0.1-0.8-0.4-1.1l-6.1,3.5 c0.2,0.3,0.3,0.7,0.3,1.1v35C373.6,131.2,373.2,131.5,372.5,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M332,71.2c0.1-0.6,0.5-0.8,1.1-0.4l39.5,22.8c0.3,0.2,0.6,0.5,0.8,0.8l6.1-3.5c-0.2-0.3-0.4-0.6-0.8-0.8 l-39.5-22.9c-0.7-0.3-1.5-0.3-2.2,0l-4,2.2C332.4,69.9,332.1,70.6,332,71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.8,99.1l7.6,8.4c0.4,0.4,0.3,1-0.1,1.4c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-6.1,3.5-6.1,3.5l-7.4-9.9 L379.8,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M379.8,99.1l7.6,8.4c0.4,0.4,0.3,1-0.1,1.4c0,0-0.1,0.1-0.1,0.1c-0.2,0.1-6.1,3.5-6.1,3.5l-7.4-9.9 L379.8,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.6,102.6l7.6,8.4c0.4,0.4,0.3,1-0.1,1.4c-0.2,0.2-0.5,0.3-0.7,0.2l-6.7-0.6 C372.8,112.1,372.8,102.6,373.6,102.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M344.5,105.9v3.6c0,0.8-0.5,1-1.5,0.4l-0.8-0.5c-0.9-0.4-1.5-1.2-1.5-2.1v-3.6c0-0.8,0.5-1,1.5-0.4l0.8,0.5 C343.9,104.1,344.5,105,344.5,105.9z M345.3,84.8c-0.4,5.2-0.8,10.4-1.3,15.7c-0.1,0.8-0.2,1.1-1.3,0.5l-0.3-0.2 c-0.8-0.3-1.3-1.1-1.3-2V82.6c0-0.8,0.5-1,1.5-0.4l1.1,0.6C344.8,83.4,345.3,84.1,345.3,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M358,97.7c0,6-4.3,4.8-4.7,8.2c-0.1,0.7-0.5,0.8-1.3,0.3l-0.6-0.3c-0.8-0.3-1.2-1-1.2-1.8 c0-1.8,0.6-3.5,1.7-4.8c1.1-1.3,2.2-2.2,2.2-3.4c0-1.4-0.7-2.6-1.9-3.3c-1.5-0.8-2.5-0.2-2.8-0.4c-0.7-0.4-1.6-3.3-1.6-4.1 c0-2.3,2.8-1.6,4.8-0.4C356,89.8,358.1,93.6,358,97.7z M353.6,111.1v3.6c0,0.8-0.5,1-1.5,0.4l-0.8-0.5c-0.9-0.4-1.5-1.2-1.5-2.1 v-3.6c0-0.8,0.5-1,1.5-0.4l0.8,0.5C352.9,109.4,353.5,110.2,353.6,111.1L353.6,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M364.5,117.5v3.6c0,0.8-0.5,1-1.5,0.4l-0.8-0.5c-0.9-0.4-1.5-1.2-1.5-2.1v-3.6c0-0.8,0.5-1,1.5-0.4l0.8,0.5 C363.9,115.7,364.5,116.5,364.5,117.5z M365.3,96.4c-0.4,5.2-0.8,10.4-1.3,15.7c-0.1,0.8-0.2,1.1-1.3,0.5l-0.3-0.2 c-0.8-0.3-1.3-1.1-1.3-2V94.1c0-0.8,0.5-1,1.5-0.4l1.1,0.6C364.8,95,365.3,95.7,365.3,96.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticalDebateAmico);
export default __webpack_public_path__ + "static/media/Political-debate-amico.5a4a9eb93f281bf2f20a8eaa341ba848.svg";
export { ForwardRef as ReactComponent };